export default () => ({
  activatedCategory: null,
  cartMenu: {},
  formattedMenu: [],
  gettingCartMenu: false,
  gettingMenu: false,
  gettingMenuList: false,
  gettingSharedMenu: false,
  memberOrders: [],
  menu: {},
  menuList: [],
});
